import { z } from 'zod';

/**
 * The mode in which the workflow should write back data.
 */
export const WorkflowWriteBackMode = z.enum([
  /**
   * Write to both the upstream API and our internal database.
   */
  'normal',

  /**
   * Update the internal database only, do not write to the upstream API.
   */
  'no-upstream',

  /**
   * Do not write back data to the internal database or the upstream API.
   */
  'no-writeback',
]);

export type WorkflowWriteBackMode = z.infer<typeof WorkflowWriteBackMode>;
